import { useBranchIndicatorsReport } from './useBranchIndicatorsReport';
import { useBranchIndicatorsReportEffects } from './useBranchIndicatorsReportEffects';

export { useBranchIndicatorsReport, useBranchIndicatorsReportEffects };
